import React from 'react'
import { Header, Link } from 'base-ui'

const Nav = () => {
  return (
    <Header size='md' title='base-ui' className='fixed w-full z-10' reverseColor={true}>
      <div className='flex space-x-5'>
        <Link
          color='default'
          href='https://github.com/paroadmin/base-ui'
          target='_blank'
          download={false}
          size='md'
          className='py-2 pr-8'
        >
          Github
        </Link>
        <Link
          color='default'
          href='https://www.npmjs.com/package/@paro.io/base-ui'
          target='_blank'
          download={false}
          size='md'
          className='py-2 pr-8'
        >
          NPM
        </Link>
        <Link
          color='default'
          href='https://www.figma.com/file/kAEfh7hoduaYlb0WX4xyu0/Base-Components?node-id=0%3A1'
          target='_blank'
          download={false}
          size='md'
          className='py-2 pr-8'
        >
          Figma
        </Link>
      </div>
    </Header>
  )
}

export default Nav
